import { Button } from '@mui/material';
import { RiShoppingCart2Fill } from 'react-icons/ri';
import { useFetchCheckoutSessionUrl } from '~/api/checkout';
import { TranslateToElement } from '~/api/useTranslationsByLabel';
import { useCommonAppContext } from '~/shared/contexts/CommonAppContext';
import { getLcn } from '~/utils/labeled-classnames';
import { PremiumIcon } from './StripePremiumDialogContent';
import { TierData } from './tiers';

type BeatsPerminutePremiumCheckoutSessionParams = {
  pricing_id: string;
};

export default function Tier({
  tierData,
  t,
}: {
  tierData: TierData
  t: TranslateToElement
}) {
  const { locale } = useCommonAppContext()
  const response = useFetchCheckoutSessionUrl<BeatsPerminutePremiumCheckoutSessionParams>({
    pricing_id: tierData.pricing_id
  });

  const lcn = getLcn({
    tier: [
      'text-white flex flex-col gap-2 items-center bg-white/5 hover:bg-white/10 p-3 rounded-md text-center ',
      !response.data && 'pointer-events-none opacity-50',
    ]
  });

  const duration = tierData.duration.reconfigure({ locale }).toHuman()

  return (
    <div className={lcn.tier}>
      <div className='flex gap-1 items-center font-semibold'>
        <div> <PremiumIcon /> </div>
        {t('get_premium.premium_access_pass', { html: true })}
      </div>
      <div className='text-lg  font-bold'> {duration}</div>
      <Button
        component='a'
        size='small'
        href={response.data}
        target='_blank'
        rel="noopener noreferrer"
        variant="contained"
        color='deeppink'
        endIcon={<RiShoppingCart2Fill />} disabled={!response.data}>
        $<span className='text-lg'>{tierData.price}</span>
      </Button>
      <div className=''></div>
    </div>
  );
}; 